import { useState } from "react";
import { useRegisterSW } from "virtual:pwa-register/react";
import { RefreshCcw } from "lucide-react";
import { Button } from "./Button";

export function UpdateToast() {
  const [dismissed, setDismissed] = useState(false);
  const {
    needRefresh: [needRefresh],
    updateServiceWorker,
  } = useRegisterSW({ immediate: true });

  if (!needRefresh || dismissed) {
    return null;
  }

  return (
    <div
      className="fixed bottom-4 right-4 z-50 flex max-w-[calc(100vw-2rem)] items-center gap-3 rounded-[var(--radius-surface)] border border-border bg-surface-elevated px-3 py-2 shadow-[var(--shadow-3)] [animation:toast-in_240ms_var(--ease-soft)_both]"
      role="status"
    >
      <span className="relative flex h-10 w-10 shrink-0 items-center justify-center rounded-pill border border-accent-200 bg-accent-50 text-accent-700 before:absolute before:inset-0 before:rounded-pill before:border before:border-accent-300 before:opacity-60 before:[animation:pulse-ring_1800ms_var(--ease-soft)_infinite]">
        <RefreshCcw aria-hidden="true" className="h-4 w-4" strokeWidth={1.5} />
      </span>
      <div className="min-w-0">
        <p className="text-sm font-semibold text-text">ClearScope update ready</p>
        <p className="text-xs font-medium text-text-muted">Save draft work before updating.</p>
      </div>
      <div className="flex shrink-0 gap-2">
        <Button size="sm" variant="ghost" onClick={() => setDismissed(true)}>
          Later
        </Button>
        <Button size="sm" onClick={() => void updateServiceWorker(true)}>
          Update
        </Button>
      </div>
    </div>
  );
}
